module.exports = __webpack_public_path__ + "img/receipt.adb065d4.svg";